module.exports = __webpack_public_path__ + "img/skull_intelligence.32025481.png";